<template>
    <modal size="lg" :height-max="true" @close="$emit('close')" ref="modal" :is-closeable="true" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Approve Payroll</h3>
        </template>

        <slot>

            <work-location-selector
                :all-work-locations="workLocations"
                :companies="companies"
                :employee-counts-by-location-id="employeeCountsByLocationId"
                :locked-location-ids="approvedLocationIds"
                v-model="formData.locationIds"
            />
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="$emit('close')">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Approve & Authorize Funding
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import WorkLocationSelector from '@/pages/client/Settings/components/WorkLocationSelector'

export default {
    props: ['client', 'payrollRun'],
    mixins: [FormMixin, ModalMixin],
    emits: ['close', 'approved', 'approving-payroll'],
    components: {WorkLocationSelector},
    computed: {
        submittedLocationIds() {
            return this.payrollRun.submittedLocationIds || []
        },
        approvedLocationIds() {
            return this.payrollRun.approvedLocationIds || []
        },
        workLocations() {
            const submitted = new Set(this.submittedLocationIds)
            return (this.payrollRun.workLocations || []).filter(wl => submitted.has(wl.id))
        },
        companies() {
            const seen = {}
            const result = []
            for (const wl of this.workLocations) {
                if (!seen[wl.company.id]) {
                    seen[wl.company.id] = true
                    result.push(wl.company)
                }
            }
            return result
        },
        employeeCountsByLocationId() {
            const counts = {}
            for (const wl of this.workLocations) {
                counts[wl.id] = wl.employee_count != null ? wl.employee_count : 0
            }
            return counts
        },
    },
    data() {
        return {
            formData: {
                locationIds: Array.from(this.payrollRun.approvedLocationIds || []),
            },
        }
    },
    methods: {
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            const url = `/clients/${this.client.id}/payroll/runs/${this.payrollRun.id}/approve`
            this.$api.post(url, {location_ids: this.formData.locationIds}).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                if (resp.task_id) {
                    this.$emit('approving-payroll', resp.task_id)
                } else {
                    this.$bus.showInfo('Locations approved.')
                    this.$emit('approved', resp)
                }
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                    return
                }
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        },
    },
}
</script>
